<template>
    <button type="button" class="btn btn-sm" :class="{'btn-success': !enabled, 'btn-danger': enabled}" v-on:click="toggle">
        <template v-if="!enabled">
            Enable
        </template>
        <template v-else>
            Disable
        </template>
    </button>
</template>

<script>
import axios from 'axios';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        enabled: Boolean,
        toggleUrl: String,
    },

    methods: {
        toggle() {
            axios.post(this.toggleUrl).then(() => Eventbus.emit('account-codes-table-refresh'));
        },
    },
}
</script>
